import React, { useEffect, useState } from 'react';
import { ITable } from '../../components/Common/iComponents/iTable/ITable';
import { Card, Container, Row } from 'reactstrap';
import { useSelector, useDispatch } from 'react-redux';
import Filters from '../../components/Common/Filters/filters';
import { transformCFColumnsData, getDynamicAttrUpdated } from '../../helpers/tools_helper';
import moment from 'moment';
import '../../components/Common/ListItems/listItems.scss';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { getItemsAggregation } from '../../store/cargoReleaseCreation/actions';
import Iloading from '../../components/Common/iComponents/iLoading/Iloading';
import { cancelFetchItemAggregation } from '../../store/cargoReleaseCreation/saga';
import { getMilestoneConfigCommodity } from '../../store/actions';

interface props {
    list: any;
    handleItemsList: Function;
    DeleteItemsList: Function;
    updateItemPieces: Function
}

const ItemAggregationCR = ({ list, handleItemsList, DeleteItemsList, updateItemPieces }: props) => {

    const [itemsMap, setItemsMap] = useState([])


    useEffect(() => {
        setItemsMap(list)
    }, [list])

    const [pagination, setPagination] = useState<any>({
        sizePerPage: 50,
        page: 1,
    });

    const groupName = 'commodityViewList';

    const { milestoneConfig, data, isLoading, CountItems } = useSelector((state: any) => {
        return {
            milestoneConfig: state.Commodity.milestoneConfig,
            isLoading: state.cargoReleaseCreation.isLoading,
            CountItems: state.cargoReleaseCreation.CountItems,
            data: state.cargoReleaseCreation.data,

        };
    });


    const currentDate = new Date();

    const [form, setForm] = useState({
        from: moment(currentDate).format('YYYY-MM-DD'),
        to: moment(currentDate).format('YYYY-MM-DD'),
        order: "{'CLEntryDate' : 'ASC'}",
        dynamicFilter: '',
    });

    const [ItemDefinitionsList, setItemDefinitionsList] = useState<any[]>([]);
    const [milestoneForFilters, setMilestoneForFilters] = useState<any[]>([]);

    const dispatch = useDispatch();

    //-------------------------
    useEffect(() => {
        dispatch(getMilestoneConfigCommodity());
    }, []);

    useEffect(() => {
        const list = milestoneConfig.filter((item:any)=>{
            return item.dataField != "CLStatus"
        })
        setMilestoneForFilters(list)
    }, [milestoneConfig]);

    useEffect(() => {
        dispatch(getItemsAggregation({ form, pagination }));
    }, [dispatch, form, pagination]);

    //-----------------------

    useEffect(() => {
        let listFinal: any[] = [];
        listFinal = transformCFColumnsData(data);
        setItemDefinitionsList(listFinal);
    }, [data]);


    const handleActionOnSearch = (data: any) => {
        const filterString = getDynamicAttrUpdated(data);
        const newForm = { ...data, order: form.order, dynamicFilter: filterString };
        setForm(newForm);
    };

    const handleActionOnRowClick = (row: any) => {
        handleItemsList(row)
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handleTableSort = (type: any, { sortField, sortOrder }: any) => {
        setForm({ ...form, order: `{'${sortField ?? 'createdAt'}' : '${sortOrder.toUpperCase()}'}` });
    };

    const onPopUpState = () => {
    };



    return (
        <React.Fragment>
            <div className="">
                <Container className='container_itemsAggregation' fluid>
                    <Container style={{ minWidth: "70%" }}>
                        <Row>
                            <Filters hideView={false} onSearchClicked={handleActionOnSearch} filterItems={milestoneForFilters} groupName={groupName} />
                        </Row>
                        <Row>
                            <div className="container-sm">
                                <Iloading cancelFetch={cancelFetchItemAggregation} loading={isLoading} />
                            </div>
                            {ItemDefinitionsList && ItemDefinitionsList.length > 0 ? (
                                milestoneConfig.length === 0 ? (
                                    <>
                                        <div>No config operations for this table</div>
                                    </>
                                ) :
                                    <>
                                        <ITable
                                            itemsTree
                                            progressCard={{ colums: "2", fontSize: "0.8rem", visibility: false }}
                                            remote={true}
                                            CountItems={CountItems}
                                            handlerPaginationState={handlePaginationChange}
                                            data={ItemDefinitionsList}
                                            fields={milestoneConfig}
                                            tableColumns={milestoneConfig}
                                            headerColorT={'bg-primary text-white'}
                                            groupName={groupName}
                                            handlePopUpState={onPopUpState}
                                            actionOnRowClick={handleActionOnRowClick}
                                            handleTableSort={handleTableSort}
                                        />
                                    </>
                            ) : (
                                <div style={{ height: 180 }} />
                            )}
                        </Row>
                    </Container>
                    <Card className='card_itemlist'>
                        <span className='title_itemsAggregationList'>Items</span>
                        <div className='itemsAggregationMap'>
                            {itemsMap.length > 0 ? (itemsMap.map((item: any, index) => {
                                return (
                                    <div className='itemMap' key={`${item.id}-${index + 1}`}>
                                        <p style={{ margin: "0px 5px" }}>{item.CLPartNumber || item.CLDescription}</p>
                                        <input min={1} onChange={(e) => { updateItemPieces(item.CLGUID, e.target.value) }} style={{ width: "60px", textAlign: "center" }} value={item.pieces} type='number' />
                                        <span className='deleteItemCR' onClick={() => { DeleteItemsList(item.CLGUID) }}><HighlightOffIcon /></span>
                                    </div>

                                )
                            })) : <p>0 items added</p>}
                        </div>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ItemAggregationCR;
